export class LessonConstants {
  public static PRIMARY_IMAGE_LITERAL = "primary_image_path";
  public static SECONDARY_IMAGE_LITERAL = "sec_image_path";
  public static TERRITIARY_IMAGE_LITERAL = "ter_image_path";
  public static QUATENARY_IMAGE_LITERAL = "quat_image_path";

  public static IMAGE_LIMIT = 20
}
